import { QuickSortStep } from "../statepattern/enums/QuickSortStep";

export function createQuickSortCodeMap() : Map<QuickSortStep, number> {
  let m: Map<QuickSortStep, number> = new Map<QuickSortStep, number>();
  
  m.set(QuickSortStep.PartitionEntry, 14);
  m.set(QuickSortStep.PartitionAssignPivot, 17);
  m.set(QuickSortStep.PartitionAssignICount, 19);
  m.set(QuickSortStep.PartitionAssignJCount, 21);
  m.set(QuickSortStep.PartitionLoopCompareJCountHI, 21);
  m.set(QuickSortStep.PartitionLoopCompareJCountPivot, 24);
  m.set(QuickSortStep.PartitionLoopIncrementICount, 26);
  m.set(QuickSortStep.PartitionLoopSwapICountJCount, 27);
  m.set(QuickSortStep.PartitionLoopIncrementJCount, 21);
  m.set(QuickSortStep.PartitionReturnPivot, 31);
  m.set(QuickSortStep.PartitionSwapPivotICount, 30);

  m.set(QuickSortStep.QuickSortAssignPartitionIndex, 7);
  m.set(QuickSortStep.QuickSortCall, 1);
  m.set(QuickSortStep.QuickSortCallPartition, 7);
  m.set(QuickSortStep.QuickSortCompareLowHigh, 3);
  m.set(QuickSortStep.QuickSortEntry, 1);
  m.set(QuickSortStep.QuickSortInit, 0);
  m.set(QuickSortStep.QuickSortLeftRecursionCall, 9);
  m.set(QuickSortStep.QuickSortReturn, 12);
  m.set(QuickSortStep.QuickSortRightRecursionCall, 10);

  return m;
}
